module.exports = __webpack_public_path__ + "static/media/edit_section_open_video.f8f5e0b1.mov";